import { dataAttrs, testAttr } from 'Helpers/Testing';
import { FDPrimaryActionButton } from '@facet-wealth/design';
import React from 'react';
import PropTypes from 'prop-types';

export const ScenarioAcceptContinueButton = ({
  resource, onClick, label, loading,
}) => {
  return (
    <FDPrimaryActionButton
      loading={loading}
      label={label}
      onClick={onClick}
      {...dataAttrs('scenario-acceptance-continue-btn', {
        [testAttr.dataType]: resource.type(),
      })}
    />
  );
};

ScenarioAcceptContinueButton.defaultProps = {
  label: 'Continue',
  loading: false,
};

ScenarioAcceptContinueButton.propTypes = {
  resource: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
  label: PropTypes.string,
  loading: PropTypes.bool,
};
